import React, { Component } from "react";
import t from "tcomb-form";
import { Link } from "react-router-dom";
// import Form from "react-bootstrap/Form";
import { Container, Button, Row, Col, Card, Image } from "react-bootstrap";
import myCustomTemplate from "../Common/customTemplate";
import "../Common/Common.css";
import "./login.css";
export interface Props {
  logins: any;
}
export interface State {}

const UserIDField = t.refinement(t.String, value => {
  return value.length === 10;
});
const PasswordMinLength = t.refinement(t.String, value => {
  return value.length > 5;
});

const Form = t.form.Form;
const Person = t.struct({
  UserID: UserIDField,
  password: PasswordMinLength
});

const options = {
  fields: {
    UserID: {
      template: myCustomTemplate,
      config: {
        placeholder: "Mobile Number",
        errorMessage: " This field is required",
        labelHide: true,
        type: "text"
      }
    },
    password: {
      template: myCustomTemplate,
      config: {
        placeholder: "Password",
        errorMessage: " This field is required",
        type: "password"
      }
    }
  }
};

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: options,
      value: {
        UserID: "",
        password: ""
      }
    };
    this.onChange = this.onChange.bind(this);
    this.submit = this.submit.bind(this);
  }
  onChange(Person1, path) {
    this.refs.form.getComponent(path).validate();
    // console.log("onchange-----", Person1, path);
  }
  submit(event) {
    var value = this.refs.form.getValue();

    event.preventDefault();
    if (value) {
      this.props.logins(value);
    }
  }

  render() {
    return (
      <div className="animated fadeIn">
        <div className="bgcolor_login container-fluid">
            <div>
              <Container>
                <Row>
                  <Col xs={12} md={12} sm={12} className="main_colum">
                    <Card className="cardMain">
                      <Card.Title className="cardhead">
                        <div className="loginpagemain">
                          <Row>
                            <Image
                              className="loginfrstImg"
                              src={require("../../assets/img/distlogo.png")}
                            />
                            {/* <h3 className="loginHead">Quik Pharma</h3> */}
                          </Row>
                        </div>
                      </Card.Title>
                      <div>
                        <h3 className="loginHd">Login</h3>
                      </div>
                      <Card.Body className="cardbodylog">
                      <form onSubmit={this.submit}>{/* Form will be submitted when enter key is pressed */}
                        <div>
                          <div className="login_form">
                            <Form
                              className="loginform"
                              ref="form"
                              type={Person}
                              options={this.state.options}
                              value={this.state.value}
                              onChange={(v, path) => this.onChange(v, path)}
                            />
                          </div>
                        </div>

                        <div className="signupbtn">
                          <div>
                            <Button
                              type="submit"
                              className="Signupsubbtn"
                              //onClick={this.submit}
                            >
                              Submit
                            </Button>
                          </div>
                        </div>
                        </form>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </div>
        </div>
      </div>
    );
  }
}

export default Login;
